import { render, staticRenderFns } from "./PaginatedTables.vue?vue&type=template&id=396a9eb6&"
import script from "./PaginatedTables.vue?vue&type=script&lang=js&"
export * from "./PaginatedTables.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports